export default __webpack_public_path__ + "static/media/rpl1.c5dc2f5a.jpg";